import styled from 'styled-components';

export const Select = styled.select`
  font-family: 'Montserrat';
  display: block;
  margin: 5px;
  background-color: inherit;
  border: none;
`;
